/*
 * Lanificio — Black Friday 2026 (ontwerp v8). Hoort bij sections/lan-black-friday-*.liquid.
 *
 * - v8: de foto in de opening zoomt mee met scrollen, achtergrondfoto's met
 *   parallax, --p op de uitrolscène, koppen en kaarten schuiven in beeld.
 *
 * - Aftelling naar vrijdag 20 november 2026 00:00, Europe/Amsterdam.
 * - Proefstuk-deadlines verdwijnen zodra de dag voorbij is (Europe/Amsterdam).
 * - Kortingsschuif (zaal 4), vragen openklappen (zaal 10), beelden groot bekijken.
 * - Aanmelden (opening en gastenboek), zolang er geen Klaviyo-formulier is
 *   ingesteld: fetch naar Klaviyo's Client Subscriptions API, net als
 *   assets/lan-newsletter.js, maar op de lijst "BF list" (V7MjAQ). Pas bij 202
 *   verschijnt "Je staat op de lijst", op beide plekken, en volgt het
 *   Shopify-event klaviyo_lead.
 * - Mobiel (onder 750px): swipe-rijen met voortgangslijn, de maandkalender
 *   achter een knop, alle vragen dicht, en een zwevende knop naar het gastenboek.
 */
(function () {
  'use strict';

  var OPENING = Date.parse('2026-11-20T00:00:00+01:00');

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  /* Datum in Amsterdam als JJJJ-MM-DD, los van de tijdzone van de bezoeker. */
  function amsterdamDate(ms) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date(ms));
      var get = function (type) {
        for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parts[i].value;
        return '';
      };
      return get('year') + '-' + get('month') + '-' + get('day');
    } catch (e) {
      /* Zonder Intl-tijdzones: november valt in CET (UTC+1). */
      return new Date(ms + 36e5).toISOString().slice(0, 10);
    }
  }

  /* ---------- Aftelling ---------- */

  function tick() {
    var diff = Math.max(0, OPENING - Date.now());
    var days = String(Math.floor(diff / 864e5));
    var els = document.querySelectorAll('[data-lbf-dagen]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== days) els[i].textContent = days;
    }
  }

  /* ---------- Proefstuk-deadlines ---------- */

  function deadlines() {
    var today = amsterdamDate(Date.now());
    var els = document.querySelectorAll('[data-lbf-deadline]');
    for (var i = 0; i < els.length; i++) {
      els[i].hidden = today > els[i].getAttribute('data-lbf-deadline');
    }
    var groups = document.querySelectorAll('[data-lbf-deadlines]');
    for (var j = 0; j < groups.length; j++) {
      groups[j].hidden = !groups[j].querySelector('[data-lbf-deadline]:not([hidden])');
    }
  }

  /* ---------- Kortingsschuif ---------- */

  function initSlider(root) {
    var range = root.querySelector('[data-lbf-prijs]');
    if (!range) return;
    var prijsLabel = root.querySelector('[data-lbf-prijslabel]');
    var kortingLabel = root.querySelector('[data-lbf-kortinglabel]');
    var treden = root.querySelectorAll('[data-lbf-trede]');
    var bedragen = [];
    for (var i = 0; i < treden.length; i++) bedragen.push(treden[i].getAttribute('data-lbf-bedrag'));

    var row = root.querySelector('[data-lbf-swipe]');

    function update(e) {
      var price = Number(range.value);
      var tier = price >= 3000 ? 2 : price >= 2000 ? 1 : 0;
      if (prijsLabel) prijsLabel.textContent = '€' + price.toLocaleString('nl-NL');
      if (kortingLabel) kortingLabel.textContent = bedragen[tier] || '';
      for (var t = 0; t < treden.length; t++) treden[t].classList.toggle('is-actief', t === tier);
      /* Mobiel staan de treden in een swipe-rij: toon de trede die nu geldt. */
      if (e && row && isMobile() && row.scrollWidth > row.clientWidth) {
        var target = treden[tier].offsetLeft - parseFloat(getComputedStyle(row).paddingLeft || 0);
        if (Math.abs(row.scrollLeft - target) > 2) {
          row.scrollTo({ left: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        }
      }
    }

    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  }

  /* ---------- Vragen ---------- */

  function setFaq(item, open) {
    item.classList.toggle('is-open', open);
    item.querySelector('button').setAttribute('aria-expanded', open ? 'true' : 'false');
    item.querySelector('[data-lbf-teken]').textContent = open ? '−' : '+';
    item.querySelector('[data-lbf-antwoord]').hidden = !open;
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-lbf-vraag]');
    /* Mobiel: alle vragen dicht bij het laden. */
    if (isMobile()) Array.prototype.forEach.call(items, function (item) { setFaq(item, false); });
    Array.prototype.forEach.call(items, function (item) {
      var btn = item.querySelector('button');
      btn.addEventListener('click', function () {
        var opening = !item.classList.contains('is-open');
        Array.prototype.forEach.call(items, function (other) {
          setFaq(other, other === item && opening);
        });
      });
    });
  }

  /* ---------- Groot bekijken ---------- */

  var zoom, zoomFoto, zoomNaam, zoomCode, lastFocus;

  function openZoom(btn) {
    if (!zoom) return;
    lastFocus = btn;
    zoomFoto.src = btn.getAttribute('data-lbf-groot');
    zoomFoto.alt = btn.getAttribute('data-lbf-alt') || '';
    zoomNaam.textContent = btn.getAttribute('data-lbf-naam') || '';
    zoomCode.textContent = btn.getAttribute('data-lbf-code') || '';
    zoom.setAttribute('aria-label', btn.getAttribute('data-lbf-naam') || '');
    zoom.hidden = false;
    zoom.focus();
  }

  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.hidden = true;
    zoomFoto.removeAttribute('src');
    if (lastFocus) lastFocus.focus();
  }

  function initZoom() {
    zoom = document.querySelector('[data-lbf-zoom]');
    if (!zoom) return;
    zoomFoto = zoom.querySelector('[data-lbf-zoom-foto]');
    zoomNaam = zoom.querySelector('[data-lbf-zoom-naam]');
    zoomCode = zoom.querySelector('[data-lbf-zoom-code]');

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-lbf-groot]');
      if (btn) openZoom(btn);
    });

    /* Klik ergens om te sluiten; de knop naar het gastenboek sluit ook. */
    zoom.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      lastFocus = link ? null : lastFocus;
      closeZoom();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeZoom();
    });
  }

  /* ---------- Aanmelden ---------- */

  /* Klaviyo Client Subscriptions API, zoals assets/lan-newsletter.js. De
     site-ID komt uit window.lanKlaviyo (layout/theme.liquid); de lijst is hier
     "BF list". Antwoord 202 = aangenomen. */
  var KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions';
  var KLAVIYO_REVISION = '2024-10-15';
  var BF_LIST = 'V7MjAQ';
  var BF_SOURCE = 'BF pagina';

  function klaviyoBody(email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: BF_SOURCE,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Lanificio aanmeldbron': BF_SOURCE,
                  'Lanificio aanmeldpagina': window.location.pathname
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: BF_LIST } } }
      }
    };
  }

  function subscribe(email) {
    var company = String((window.lanKlaviyo || {}).company || '').trim();
    if (!company) return Promise.reject(new Error('Geen Klaviyo-site-ID'));
    return fetch(KLAVIYO_URL + '?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(klaviyoBody(email))
    }).then(function (response) {
      if (response.status !== 202) throw new Error('Klaviyo ' + response.status);
    });
  }

  function publishLead() {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('klaviyo_lead', { source: 'bf-pagina' });
      }
    } catch (e) { /* meten mag aanmelden nooit breken */ }
  }

  function initSignupForms() {
    var forms = document.querySelectorAll('[data-lbf-demo]');
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var fout = form.parentNode.querySelector('[data-lbf-fout]');
      var ongeldig = fout ? fout.textContent : '';
      var mislukt = fout ? fout.getAttribute('data-lbf-fout-versturen') : '';

      function toonFout(text) {
        if (!fout) return;
        fout.textContent = text;
        fout.hidden = false;
      }

      input.addEventListener('input', function () {
        if (fout) fout.hidden = true;
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (button.disabled) return;
        var email = input.value.trim();
        if (!/.+@.+\..+/.test(email)) {
          toonFout(ongeldig);
          return;
        }
        if (fout) fout.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        subscribe(email).then(function () {
          /* Net als in het ontwerp: aangemeld geldt voor beide plekken. */
          var blocks = document.querySelectorAll('[data-lbf-aanmelden]');
          Array.prototype.forEach.call(blocks, function (block) {
            var open = block.querySelector('[data-lbf-open]');
            var klaar = block.querySelector('[data-lbf-klaar]');
            if (open) open.hidden = true;
            if (klaar) klaar.hidden = false;
          });
          publishLead();
          document.dispatchEvent(new CustomEvent('lbf:aangemeld'));
        }, function () {
          toonFout(mislukt || ongeldig);
        }).then(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
      });
    });
  }

  /* ---------- De draad ---------- */

  /* Elke svg.lbf-draad tekent zich met het scrollen: de punt van de draad volgt
     een lijn op 85% van de schermhoogte. Scrol je terug, dan trekt hij terug.
     De lijnen hebben vector-effect: non-scaling-stroke, dus streepjes rekenen
     in schermpixels: de lengte wordt in pixels gemeten (--lbf-len), net als
     het stuk van de sectie waar de lijn loopt (--lbf-y0 en --lbf-y1).
     Kan de browser scroll-driven animations, dan tekent CSS de lijn
     (assets/lan-black-friday.css); anders zet dit script stroke-dashoffset.
     Een garenbol (.lbf-bol) licht op zodra de punt van de draad hem bereikt. */
  var TIP = 0.85;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function measureThread(d) {
    var w = d.svg.clientWidth;
    var h = d.svg.clientHeight;
    var total = d.path.getTotalLength();
    var len = 0;
    var prev = null;
    for (var i = 0; i <= 96; i++) {
      var pt = d.path.getPointAtLength(total * i / 96);
      var x = pt.x * w / 100;
      var y = pt.y * h / 100;
      if (prev) len += Math.sqrt((x - prev[0]) * (x - prev[0]) + (y - prev[1]) * (y - prev[1]));
      prev = [x, y];
    }
    var box = d.path.getBBox();
    d.len = Math.ceil(len) + 2;
    d.y0 = box.y / 100;
    d.y1 = (box.y + box.height) / 100;
    d.path.style.setProperty('--lbf-len', d.len + 'px');
    d.path.style.setProperty('--lbf-y0', d.y0.toFixed(4));
    d.path.style.setProperty('--lbf-y1', d.y1.toFixed(4));
  }

  function initThread() {
    if (prefersReducedMotion()) return;
    var cssDriven = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));

    var threads = [];
    Array.prototype.forEach.call(document.querySelectorAll('.lbf-draad'), function (svg) {
      var path = svg.querySelector('path');
      var section = svg.parentNode;
      if (!path || !section || !path.getTotalLength) return;
      threads.push({ svg: svg, path: path, section: section });
    });
    if (!threads.length) return;
    threads.forEach(measureThread);

    var bols = Array.prototype.slice.call(document.querySelectorAll('.lbf .lbf-bol'));

    var queued = false;
    function update() {
      queued = false;
      var tip = window.innerHeight * TIP;
      /* Eerst alles lezen, dan pas schrijven: geen gedwongen layout. */
      var offsets = cssDriven ? null : threads.map(function (d) {
        var r = d.section.getBoundingClientRect();
        var start = r.top + d.y0 * r.height;
        var end = r.top + d.y1 * r.height;
        var p = end > start ? (tip - start) / (end - start) : (tip >= start ? 1 : 0);
        p = Math.max(0, Math.min(1, p));
        return d.len * (1 - p);
      });
      var lit = bols.map(function (bol) {
        var r = bol.getBoundingClientRect();
        return r.top + r.height / 2 <= tip;
      });
      if (offsets) threads.forEach(function (d, i) { d.path.style.strokeDashoffset = offsets[i].toFixed(1); });
      bols.forEach(function (bol, i) { bol.classList.toggle('is-lit', lit[i]); });
    }
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    /* Het thema scrolt op desktop binnen .page-wrapper: capture vangt beide. */
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        threads.forEach(measureThread);
        schedule();
      });
      threads.forEach(function (d) { ro.observe(d.svg); });
    }

    update();
    document.documentElement.classList.add('lbf-draad-aan');
  }

  /* ---------- Foto's zoomen één keer zacht in ---------- */

  function initPhotoZoom() {
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) return;
    var imgs = document.querySelectorAll('.lbf-z2__lijst img, .lbf-z4__foto img, .lbf-z6__foto img, .lbf-z7__foto img, .lbf-z8__lijst img');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var img = entry.target;
        io.unobserve(img);
        var go = function () { img.classList.add('is-gezien'); };
        if (img.complete) go();
        else {
          img.addEventListener('load', go, { once: true });
          img.addEventListener('error', go, { once: true });
        }
      });
    }, { threshold: 0.15 });
    Array.prototype.forEach.call(imgs, function (img) {
      img.classList.add('lbf-inzoom');
      io.observe(img);
    });
  }

  /* ---------- Scroll-effecten (ontwerp v8) ---------- */

  /* - Opening: de foto zoomt mee in tot 1.2 terwijl je de opening uit scrolt.
     - Achtergrondfoto's ([data-lbf-bgpar]) schuiven langzamer dan de pagina.
     - Elke [data-scene] krijgt --p, 0 tot 1 over de plakkende scène.
     Alles via getBoundingClientRect: het thema scrolt op desktop binnen
     .page-wrapper, dus window.scrollY blijft daar 0. */
  function initFilm() {
    var scenes = document.querySelectorAll('.lbf[data-scene]');
    var reduce = prefersReducedMotion();
    var bgs = reduce ? [] : document.querySelectorAll('[data-lbf-bgpar]');
    var hero = reduce ? null : document.querySelector('[data-lbf-hero-foto]');
    if (!scenes.length && !bgs.length && !hero) return;

    var queued = false;
    function update() {
      queued = false;
      var vh = window.innerHeight;
      var i, r;
      var sceneP = [];
      for (i = 0; i < scenes.length; i++) {
        r = scenes[i].getBoundingClientRect();
        sceneP.push(Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh))));
      }
      var bgT = [];
      for (i = 0; i < bgs.length; i++) {
        r = bgs[i].parentElement.getBoundingClientRect();
        bgT.push(r.bottom < -200 || r.top > vh + 200 ? null : (vh - r.top) / (vh + r.height));
      }
      var heroP = null;
      if (hero) {
        var box = hero.parentElement;
        r = box.getBoundingClientRect();
        if (r.bottom > -50) heroP = Math.min(1, Math.max(0, -(r.top - box.offsetTop) / (box.offsetHeight || 1)));
      }
      for (i = 0; i < scenes.length; i++) scenes[i].style.setProperty('--p', sceneP[i].toFixed(4));
      for (i = 0; i < bgs.length; i++) {
        if (bgT[i] !== null) bgs[i].style.transform = 'translate3d(0,' + ((bgT[i] - 0.5) * -10).toFixed(2) + '%,0)';
      }
      if (heroP !== null) hero.style.transform = 'scale(' + (1 + heroP * 0.2).toFixed(4) + ') translate3d(0,' + (heroP * 5).toFixed(2) + '%,0)';
    }
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  /* Koppen en kaarten schuiven één keer omhoog in beeld. Alleen wat bij het
     laden onder de vouw staat. In een swipe-rij op mobiel schuift de rij als
     geheel, niet elke kaart apart. */
  function initReveal() {
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    var targets = [];
    Array.prototype.forEach.call(document.querySelectorAll('.lbf:not([data-scene]) .lbf-h2'), function (el) {
      targets.push([el, 0]);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.lbf [data-reveal-group]'), function (group) {
      if (isMobile() && group.hasAttribute('data-lbf-swipe')) {
        targets.push([group, 0]);
        return;
      }
      Array.prototype.forEach.call(group.children, function (el, i) {
        targets.push([el, (i % 6) * 90]);
      });
    });

    var vh = window.innerHeight;
    targets.forEach(function (t) {
      if (t[0].getBoundingClientRect().top < vh) return;
      t[0].style.setProperty('--lbf-d', t[1] + 'ms');
      t[0].classList.add('lbf-reveal');
      io.observe(t[0]);
    });
  }

  /* ---------- Mobiel: swipe-rijen ---------- */

  /* De voortgangslijn onder een rij vult mee met het swipen (alleen transform). */
  function initSwipes() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lbf-swipe]'), function (row) {
      var bar = row.nextElementSibling;
      var fill = bar && bar.hasAttribute('data-lbf-voortgang') ? bar.firstElementChild : null;
      if (!fill) return;
      var queued = false;
      function update() {
        queued = false;
        var p = row.scrollWidth > 0 ? (row.scrollLeft + row.clientWidth) / row.scrollWidth : 1;
        fill.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)).toFixed(4) + ')';
      }
      function schedule() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }
      row.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();
    });
  }

  /* ---------- Mobiel: de hele maand ---------- */

  function initMonth() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lbf-maand-knop]'), function (btn) {
      var section = btn.closest('.lbf-z5');
      if (!section) return;
      section.classList.add('lbf-z5--klap');
      btn.addEventListener('click', function () {
        var open = !section.classList.contains('is-maand-open');
        section.classList.toggle('is-maand-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = btn.getAttribute(open ? 'data-dicht' : 'data-open');
      });
    });
  }

  /* ---------- Mobiel: zwevende knop ---------- */

  /* Verschijnt zodra het formulier in de opening voorbij is, verdwijnt zodra
     het formulier in het gastenboek in beeld is, en na een aanmelding voorgoed. */
  function initFloatingButton() {
    var btn = document.querySelector('[data-lbf-zweef]');
    var hero = document.querySelector('.lbf-hero [data-lbf-aanmelden]');
    var guestbook = document.querySelector('#gastenboek [data-lbf-aanmelden]');
    if (!btn || !hero || !guestbook || !('IntersectionObserver' in window)) return;
    var heroPast = false;
    var guestbookInView = false;
    var done = false;

    function render() {
      btn.classList.toggle('is-zichtbaar', heroPast && !guestbookInView && !done);
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        heroPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      });
      render();
    }).observe(hero);

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        guestbookInView = entry.isIntersecting;
      });
      render();
    }).observe(guestbook);

    function finish() {
      done = true;
      render();
    }
    document.addEventListener('lbf:aangemeld', finish);
    window.addEventListener('klaviyoForms', function (e) {
      if (e.detail && e.detail.type === 'submit') finish();
    });

    btn.addEventListener('click', function () {
      guestbook.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function init() {
    initThread();
    initPhotoZoom();
    initFilm();
    initReveal();
    tick();
    setInterval(tick, 60000);
    deadlines();
    setInterval(deadlines, 60000);
    Array.prototype.forEach.call(document.querySelectorAll('[data-lbf-schuif]'), initSlider);
    Array.prototype.forEach.call(document.querySelectorAll('[data-lbf-vragen]'), initFaq);
    initZoom();
    initSignupForms();
    initSwipes();
    initMonth();
    initFloatingButton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
